import { Card, Stack } from "@mui/material";
import InvoiceExportButton from "components/CustomButtons/InvoiceExportButton";
import InvoicesTable from "components/CustomTables/InvoicesTable";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function InvoicesListCard({ companyId, fromDate, toDate, setInvoiceSummaries }) {
  return (
    <SoftBox my={3}>
      <Card>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Λίστα Παραστατικών
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              Η λίστα περιέχει τα παραστατικά για τα φίλτρα αναζήτησης που έχετε ορίσει.
            </SoftTypography>
          </SoftBox>
          <Stack spacing={1} direction="row">
            <InvoiceExportButton companyId={companyId} fromDate={fromDate} toDate={toDate} />
          </Stack>
        </SoftBox>
        <InvoicesTable
          companyId={companyId}
          fromDate={fromDate}
          toDate={toDate}
          setInvoiceSummaries={setInvoiceSummaries}
        />
      </Card>
    </SoftBox>
  );
}

export default InvoicesListCard;
